import React from 'react'
import { Avatar, Typography } from '@material-ui/core'
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles'
import { compose } from 'recompose'
import { WithGlobalStylesProps } from 'types/styles/WithGlobalStylesProps'
import FieldValuePairStyles from './FieldValuePair.styles'
import cn from 'classnames'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'

interface Props {
  fieldName: string,
  valueText: string,
}

type FProps = Props & WithGlobalStylesProps<any>

const FieldValuePair = (props: FProps) => {
  const {
    classes,
    fieldName,
    valueText,
  } = props

  return (
    <div className={classes.wrapper}>
      <Typography variant='subtitle2' className={classes.fieldName}>{fieldName}</Typography>
      <Typography
        variant='subtitle1'
        data-mf-replace-inner={MFSDR}
      >
        {valueText}
      </Typography>
    </div>
  )
}


export default compose<FProps, Props>(
  withGlobalStyles(FieldValuePairStyles),
)(FieldValuePair)
